import {SORespProcessStepAssociation} from '../../core/process-step-association/so-resp-process-step-association';
import {ProcessStepAssociationCore} from './process-step-association.core';
import {ListEntry, CEProtocol, CEBase, createCEProtocol, RowSpec} from 'lionheartland';
import {
  DetailEntry, ScopeMatch,
  DetailFactory, DetailFactoryProtocol, EditableType
} from 'lionheartland';
import {BaseDetailType} from 'lionheartland';
import {EntityAttributesForDisplay} from 'lionheartland';
import {getHeading} from 'lionheartland';
import {ListSpecType} from 'lionheartland';
import {DisplayVectorStringFactory} from 'lionheartland';
import {ActiveUserService} from 'lionheartland';
import {EntityViewSpecProtocol} from 'lionheartland';
import { CommanderApp } from "../../land-app";
import {PutProcessStepAssociationFormFields} from './put-process-step-association-form-fields';
import {SOGetProcessStepAssociation} from '../../core/process-step-association/so-get-process-step-association';
import {SOGetProcess} from '../../core/process/so-get-process';
import {SOGetStep} from '../../core/step/so-get-step';
import {SOGetProject} from '../../core/project/so-get-project';
import {SOGetOrganization} from '../../core/organization/so-get-organization';


export class CEProcessStepAssociationAttributesBase {

    name: DetailEntry
    processStepType: DetailEntry
    process: DetailEntry
    step: DetailEntry
    project: DetailEntry

    constructor(
        parentEntityViewSpec: EntityViewSpecProtocol,
        entity: SORespProcessStepAssociation,
        app: CommanderApp,
        formFields: PutProcessStepAssociationFormFields
    ) {

        const displayStringFactory = new DisplayVectorStringFactory(app.displayOptions);
        let heading;


        this.name = new DetailEntry(
            'Name',
            entity.name,
            'name',
            BaseDetailType.text,
            null,
            EditableType.always,
            formFields.name
        )

        this.processStepType = new DetailEntry(
            'Process step type',
            entity.processStepType,
            'processStepType',
            BaseDetailType.toggleGroup,
            null,
            EditableType.always,
            formFields.processStepType
        )


        const processCore = app.makeCore( 'process');
        processCore.soGet = SOGetProcess.construct({
          organization: app.getScope('organization') ? new SOGetOrganization(app.getScope('organization').uid) : null,
        });
        processCore.soGet.queryOptions.sortKey = 'dateCreated';
        processCore.soGet.queryOptions.descending = true;
        let processCeProtocol;
        if (entity.process) {
            processCeProtocol = createCEProtocol(
                processCore.ceProtocol,
                parentEntityViewSpec,
                processCore,
                entity.process,
                app
            )
        }
        heading = getHeading(
            parentEntityViewSpec ? parentEntityViewSpec.entityCore : null,
            processCore
        )
        processCore.title = heading ? heading : processCore.title
        processCore.listTitle = 'Process'

        if (entity.process) {
            displayStringFactory.reconfigure(
                entity.process,
                parentEntityViewSpec ? parentEntityViewSpec.entityCore.type : null
            )
        }
        processCore.configureForDisplay(parentEntityViewSpec)

        this.process = new DetailEntry(
          heading ? heading : processCore.listTitle,
          processCeProtocol ? processCeProtocol.entityListView.fullHeading : null,
          'process',
          BaseDetailType.pushedDetail,
          processCore,
          EditableType.always,
          formFields.process
        )
        if (entity.process) {
          this.process.ceProtocol = processCeProtocol;
          this.process.cachedListEntry = processCore.makeListEntry(parentEntityViewSpec, entity.process, 0)
          processCore.selectedEntity = entity.process;
        }
        this.process.singleFieldSelect = true

        const stepCore = app.makeCore( 'step');
        stepCore.soGet = SOGetStep.construct({
          organization: app.getScope('organization') ? new SOGetOrganization(app.getScope('organization').uid) : null,
        });
        stepCore.soGet.queryOptions.sortKey = 'dateCreated';
        stepCore.soGet.queryOptions.descending = true;
        let stepCeProtocol;
        if (entity.step) {
            stepCeProtocol = createCEProtocol(
                stepCore.ceProtocol,
                parentEntityViewSpec,
                stepCore,
                entity.step,
                app
            )
        }
        heading = getHeading(
            parentEntityViewSpec ? parentEntityViewSpec.entityCore : null,
            stepCore
        )
        stepCore.title = heading ? heading : stepCore.title
        stepCore.listTitle = 'Step'

        if (entity.step) {
            displayStringFactory.reconfigure(
                entity.step,
                parentEntityViewSpec ? parentEntityViewSpec.entityCore.type : null
            )
        }
        stepCore.configureForDisplay(parentEntityViewSpec)

        this.step = new DetailEntry(
          heading ? heading : stepCore.listTitle,
          stepCeProtocol ? stepCeProtocol.entityListView.fullHeading : null,
          'step',
          BaseDetailType.pushedDetail,
          stepCore,
          EditableType.always,
          formFields.step
        )
        if (entity.step) {
          this.step.ceProtocol = stepCeProtocol;
          this.step.cachedListEntry = stepCore.makeListEntry(parentEntityViewSpec, entity.step, 0)
          stepCore.selectedEntity = entity.step;
        }
        this.step.singleFieldSelect = true

        const projectCore = app.makeCore( 'project');
        projectCore.soGet = SOGetProject.construct({
          organization: app.getScope('organization') ? new SOGetOrganization(app.getScope('organization').uid) : null,
        });
        projectCore.soGet.queryOptions.sortKey = 'dateCreated';
        projectCore.soGet.queryOptions.descending = true;
        let projectCeProtocol;
        if (entity.project) {
            projectCeProtocol = createCEProtocol(
                projectCore.ceProtocol,
                parentEntityViewSpec,
                projectCore,
                entity.project,
                app
            )
        }
        heading = getHeading(
            parentEntityViewSpec ? parentEntityViewSpec.entityCore : null,
            projectCore
        )
        projectCore.title = heading ? heading : projectCore.title
        projectCore.listTitle = 'Project'

        if (entity.project) {
            displayStringFactory.reconfigure(
                entity.project,
                parentEntityViewSpec ? parentEntityViewSpec.entityCore.type : null
            )
        }
        projectCore.configureForDisplay(parentEntityViewSpec)

        this.project = new DetailEntry(
          heading ? heading : projectCore.listTitle,
          projectCeProtocol ? projectCeProtocol.entityListView.fullHeading : null,
          'project',
          BaseDetailType.pushedDetail,
          projectCore,
          EditableType.always,
          formFields.project
        )
        if (entity.project) {
          this.project.ceProtocol = projectCeProtocol;
          this.project.cachedListEntry = projectCore.makeListEntry(parentEntityViewSpec, entity.project, 0)
          projectCore.selectedEntity = entity.project;
        }
        this.project.singleFieldSelect = true
    }
}